import firebase from 'firebase/compat/app'
import 'firebase/compat/firestore'


const firebaseConfig = {
  apiKey: "AIzaSyCxa5KFh8P9FgD1hjNXGO4ivYBAbn1ijLI",
  authDomain: "chargd-3cef3.firebaseapp.com",
  projectId: "chargd-3cef3",
  storageBucket: "chargd-3cef3.appspot.com",
  messagingSenderId: "104961399239",
  appId: "1:104961399239:web:88e715f1009eb23c4421e2"
}

const firebaseApp = firebase.initializeApp(firebaseConfig)

export default firebaseApp.firestore()